import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';

export default function Datenschutz() {
    const [kontakte, setKontakte] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch("/api/kontakte.php", {
            credentials: "include"
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Kontakte konnten nicht geladen werden");
                }

                return response.json();
            })
            .then((data) => {
                setKontakte(data.contact ?? []);
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <p> Wird geladen...</p>;
    }

    return (
        <div style={pageStyle}>
            <div style={panelStyle}>
                <Link to="/" style={backLinkStyle}>← Zurück zum Universum</Link>

                <h1 style={titleStyle}>Datenschutzerklärung</h1>

                <Section title="Verantwortlicher">
                    {kontakte.map((kontakt, index) => (
                        <div key={index}>
                            <p style={lineStyle}>{kontakt.name}</p>
                            <p style={lineStyle}>{kontakt.strasse}</p>
                            <p style={lineStyle}>{kontakt.plz}</p>
                            <p style={lineStyle}>E-Mail: {kontakt.email}</p>
                        </div>
                    ))}
                </Section>

                <Section title="Allgemeine Hinweise">
                    <p style={lineStyle}>
                        Diese Datenschutzerklärung klärt darüber auf, wie personenbezogene Daten auf diesem rein privaten,
                        passwortgeschützten Bewerbungs-Portfolio verarbeitet werden.
                        Personenbezogene Daten sind alle Informationen, mit denen Sie persönlich identifiziert werden können.
                    </p>
                </Section>

                <Section title="Hosting durch Strato & Server-Log-File">
                    <p style={lineStyle}>
                        Dieses Portfolio wird bei der STRATO AG (Otto-Ostrowski-Straße 7, 10249 Berlin) gehostet.
                        Strato erhebt und speichert automatisch technische Informationen in sogenannten Server-Log-Files,
                        die Ihr Browser übermittelt (z.B. Browsertyp, Betriebssystem, IP-Adresse, Uhrzeit).
                        Diese Daten sind technisch notwendig, um die Website fehlerfrei anzuzeigen und
                        vor Angriffen zu schützen (Art. 6 Abs. 1 lit. f DSGVO). Eine Zusammenführung mit anderen Datenquellen erfolgt nicht.
                    </p>
                </Section>

                <Section title="Cookies (Passwortschutz)">
                    <p style={lineStyle}>
                        Diese Website verwendet ausschließlich technisch notwendige Session-Cookies,
                        die für die Funktion des Passwortschutzes zwingend erforderlich sind.
                        Diese Cookies speichern keine personenbezogenen Daten und werden nach dem Schließen des Browsers gelöscht.
                        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
                    </p>
                </Section>

                <Section title="Kontakt per E-Mail ">
                    <p style={lineStyle}>
                        Wenn Sie mich bezüglich einer Bewerbung oder eines Projekts per E-Mail kontaktieren,
                        speichere ich Ihre E-Mail-Adresse und Nachricht ausschließlich zur Bearbeitung der Anfrage.
                        Eine Weitergabe an Dritte erfolgt nicht ohne Ihre Zustimmung.
                    </p>
                </Section>
            </div>
        </div>
    );
}

function Section({title, children}) {
    return (
        <section style={{marginBottom: '24px'}}>
            <h2 style={sectionTitleStyle}>{title}</h2>
            {children}
        </section>
    );
}

const pageStyle = {
    height: "90%",
    background: '#ffffff',
    display: 'flex',
    justifyContent: 'center',
    padding: '8vh 24px',
    boxSizing: 'border-box',
    fontFamily: 'system-ui, sans-serif',
    color: '#111',
    overflow: 'auto',
};
const panelStyle = {maxWidth: '640px', width: '100%'};
const titleStyle = {fontSize: '28px', margin: '5px 0 32px'};
const sectionTitleStyle = {fontSize: '16px', fontWeight: 600, margin: '0 0 8px'};
const lineStyle = {margin: '2px 0', color: '#444', lineHeight: 1.5};
const backLinkStyle = {display: 'inline-block', marginTop: '32px', color: '#111'};
